<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div
      class="doc-paper preview english-resume"
      :id="idPrefix + 'preview-page-01'"
      style="
        width: 210mm;
        height: auto;
        min-height: 0;
        padding: 15mm 18mm;
        box-sizing: border-box;
        font-family: 'Helvetica Neue', Arial, 'Hiragino Sans', sans-serif;
        color: #222;
        font-size: 10.5pt;
        line-height: 1.45;
        background: #fff;
      "
    >
      <div style="width: 100%">
        <!-- ヘッダー -->
        <header
          style="
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            margin-bottom: 20px;
          "
          :data-highlight="highlightMessage"
          @click="goCardTo('en-profile')"
          :class="highLightClass('en-profile')"
        >
          <h1
            style="
              display: inline-block;
              font-size: 22pt;
              font-weight: 700;
              text-decoration: none;
              color: #222;
              margin: 0;
              letter-spacing: 0.5px;
            "
          >
            {{ fullName }}
          </h1>
          <p
            v-if="formatData.recentPosition"
            style="
              display: inline-block;
              font-size: 12px;
              border: 1px solid #000;
              border-radius: 50px;
              padding: 3px 8px;
              color: #444;
              margin: 0;
            "
          >
            {{ formatData.recentPosition }}
          </p>
        </header>

        <!-- 上段：INFO / PROFILE -->
        <section
          style="display: flex; gap: 14mm; width: 100%; margin-bottom: 30px"
        >
          <div
            style="
              flex: 1 1 50%;
              min-width: 0;
              padding-right: 0;
              margin-right: 0;
            "
            :data-highlight="highlightMessage"
          >
            <h2
              style="
                display: block;
                font-size: 20px;
                font-weight: 700;
                letter-spacing: 1.5px;
                margin: 0 0 12px;
                text-transform: uppercase;
                text-align: left;
                color: #222;
                border-bottom: 2px solid #222;
                padding-bottom: 3px;
              "
            >
              INFO
            </h2>
            <dl
              style="display: flex; gap: 8px; margin: 0 0 4px"
              :data-highlight="highlightMessage"
              @click="goCardTo('en-address')"
              :class="highLightClass('en-address')"
            >
              <dt style="flex: 0 0 70px; font-weight: 600">Address</dt>
              <dd
                style="
                  flex: 1;
                  margin: 0;
                  word-break: break-all;
                  white-space: pre-wrap;
                "
              >
                {{ fullAddress }}
              </dd>
            </dl>
            <dl
              style="display: flex; gap: 8px; margin: 0 0 4px"
              :data-highlight="highlightMessage"
              @click="goCardTo('en-profile')"
              :class="highLightClass('en-profile')"
            >
              <dt style="flex: 0 0 70px; font-weight: 600">Phone</dt>
              <dd style="flex: 1; margin: 0; word-break: break-all">
                {{ fullPhone }}
              </dd>
            </dl>
            <dl
              style="display: flex; gap: 8px; margin: 0 0 4px"
              :data-highlight="highlightMessage"
              @click="goCardTo('en-profile')"
              :class="highLightClass('en-profile')"
            >
              <dt style="flex: 0 0 70px; font-weight: 600">Email</dt>
              <dd style="flex: 1; margin: 0; word-break: break-all">
                {{ basicData.email }}
              </dd>
            </dl>
            <dl
              v-if="formatData.website"
              style="display: flex; gap: 8px; margin: 0 0 4px"
              :data-highlight="highlightMessage"
              @click="goCardTo('en-profile')"
              :class="highLightClass('en-profile')"
            >
              <dt style="flex: 0 0 70px; font-weight: 600">Website</dt>
              <dd style="flex: 1; margin: 0; word-break: break-all">
                {{ formatData.website }}
              </dd>
            </dl>
          </div>
          <div style="flex: 1 1 50%; min-width: 0">
            <h2
              style="
                display: block;
                font-size: 20px;
                font-weight: 700;
                letter-spacing: 1.5px;
                margin: 0 0 12px;
                text-transform: uppercase;
                text-align: left;
                color: #222;
                border-bottom: 2px solid #222;
                padding-bottom: 3px;
              "
            >
              PROFILE
            </h2>
            <div
              :id="idPrefix + 'pr-message'"
              :data-highlight="highlightMessage"
              @click="goCardTo('pr-message')"
              :class="highLightClass('pr-message')"
            >
              <pre
                style="
                  font-family: inherit;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                  margin: 0;
                  font-size: 10pt;
                  line-height: 1.5;
                "
                >{{ formatData.prMessage }}</pre>
            </div>
          </div>
        </section>

        <!-- 中段：EDUCATION / EXPERIENCE -->
        <section style="display: flex; gap: 14mm; margin-bottom: 8px">
          <div
            style="
              flex: 1 1 50%;
              min-width: 0;
              padding-right: 0;
              margin-right: 0;
            "
          >
            <h2
              style="
                display: block;
                font-size: 20px;
                font-weight: 700;
                letter-spacing: 1.5px;
                margin: 0 0 12px;
                text-transform: uppercase;
                text-align: left;
                color: #222;
                border-bottom: 2px solid #222;
                padding-bottom: 3px;
              "
            >
              EDUCATION
            </h2>
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('edu-history')"
              :class="highLightClass('edu-history')"
            >
              <div
                v-for="item in formatData.educationalHistories"
                :key="item.uuid"
                style="margin-bottom: 20px"
              >
                <p style="margin: 0; font-weight: 600">
                  {{ item.description }}
                </p>
                <p
                  v-if="item.year || item.month"
                  style="margin: 0; font-size: 9.5pt; color: #555"
                >
                  {{ formatMonthYear(item.month, item.year) }}
                </p>
              </div>
            </div>

            <template v-if="formatData.skills && formatData.skills.length">
              <h2
                style="
                  display: block;
                  font-size: 20px;
                  font-weight: 700;
                  letter-spacing: 1.5px;
                  margin: 10px 0 12px;
                  text-transform: uppercase;
                  text-align: left;
                  color: #222;
                  border-bottom: 2px solid #222;
                  padding-bottom: 3px;
                "
                :id="idPrefix + 'skills'"
              >
                CAPABILITIES/SKILLS
              </h2>
              <ul
                style="list-style: none; padding-left: 0; margin: 0 0 50px"
                :data-highlight="highlightMessage"
                @click="goCardTo('skills')"
                :class="highLightClass('skills')"
              >
                <li
                  v-for="(skill, index) in formatData.skills"
                  :key="'skill-' + index"
                  style="font-weight: 600; margin-bottom: 3px"
                >
                  {{ skill }}
                </li>
              </ul>
            </template>
          </div>

          <div style="flex: 1 1 50%; min-width: 0">
            <template
              v-if="
                formatData.licenseHistories &&
                formatData.licenseHistories.length
              "
            >
              <h2
                style="
                  display: block;
                  font-size: 20px;
                  font-weight: 700;
                  letter-spacing: 1.5px;
                  margin: 0 0 12px;
                  text-transform: uppercase;
                  text-align: left;
                  color: #222;
                  border-bottom: 2px solid #222;
                  padding-bottom: 3px;
                "
              >
                LICENSES
              </h2>
              <ul
                style="list-style: none; padding-left: 0; margin: 0 0 20px"
                :data-highlight="highlightMessage"
                @click="goCardTo('license-history')"
                :class="highLightClass('license-history')"
              >
                <li
                  v-for="item in formatData.licenseHistories"
                  :key="item.uuid"
                  style="margin-bottom: 3px; font-weight: 600"
                >
                  <span>{{ item.description }}</span>
                  <span
                    v-if="item.year || item.month"
                    style="
                      color: #555;
                      font-size: 9.5pt;
                      font-weight: normal;
                      margin-left: 4px;
                    "
                  >
                    （{{ formatMonthYear(item.month, item.year) }}）
                  </span>
                </li>
              </ul>
            </template>

            <h2
              style="
                display: block;
                font-size: 20px;
                font-weight: 700;
                letter-spacing: 1.5px;
                margin: 0 0 12px;
                text-transform: uppercase;
                text-align: left;
                color: #222;
                border-bottom: 2px solid #222;
                padding-bottom: 3px;
              "
            >
              EXPERIENCE
            </h2>
            <div
              :id="idPrefix + 'job-history'"
              :data-highlight="highlightMessage"
              @click="goCardTo('job-history')"
              :class="highLightClass('job-history')"
            >
              <template v-for="job in jobsPage1">
                <div
                  v-for="(project, pIndex) in job.projects &&
                  job.projects.length
                    ? job.projects
                    : [null]"
                  :key="job.uuid + '-' + pIndex"
                  style="margin-bottom: 10px"
                >
                  <h3
                    v-if="project && project.projectTitle"
                    style="
                      display: block;
                      font-size: 11pt;
                      font-weight: 700;
                      color: #222;
                      text-align: left;
                      margin: 0;
                    "
                  >
                    {{ project.projectTitle }}
                  </h3>
                  <h3
                    v-else-if="pIndex === 0 && job.companyName"
                    style="
                      display: block;
                      font-size: 11pt;
                      font-weight: 700;
                      color: #222;
                      text-align: left;
                      margin: 0;
                    "
                  >
                    {{ job.companyName }}
                  </h3>
                  <p style="margin: 0; font-size: 9.5pt; color: #555">
                    {{ formatExperiencePeriod(job, project) }}
                  </p>
                  <p
                    v-if="job.companyName"
                    style="margin: 0 0 2px; font-style: italic"
                  >
                    {{ job.companyName }}
                  </p>
                  <pre
                    v-if="project && project.contentsOfProject"
                    style="
                      font-family: inherit;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      margin: 0;
                      font-size: 10pt;
                      line-height: 1.5;
                    "
                    >{{ project.contentsOfProject }}</pre>
                  <pre
                    v-else-if="!project && job.businessArea"
                    style="
                      font-family: inherit;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      margin: 0;
                      font-size: 10pt;
                      line-height: 1.5;
                    "
                    >{{ job.businessArea }}</pre>
                </div>
              </template>
            </div>
          </div>
        </section>

        <!-- 作成日 -->
        <footer
          style="
            margin-top: 20px;
            text-align: right;
            font-size: 9.5pt;
            color: #555;
          "
        >
          <div
            :data-highlight="highlightMessage"
            @click="goCardTo('create-date')"
            :class="highLightClass('create-date')"
          >
            <span>{{ formatedCreateDate }}</span>
          </div>
        </footer>
      </div>
    </div>

    <!-- 2ページ目（jobHistories が3件超のときのみ）— page-break-before で印刷時に確実に改ページ -->
    <div
      v-if="isTwoPage"
      class="doc-paper preview english-resume"
      :id="idPrefix + 'preview-page-02'"
      style="
        width: 210mm;
        height: auto;
        min-height: 0;
        padding: 15mm 18mm;
        box-sizing: border-box;
        font-family: 'Helvetica Neue', Arial, 'Hiragino Sans', sans-serif;
        color: #222;
        font-size: 10.5pt;
        line-height: 1.45;
        background: #fff;
        margin-top: 20px;
        page-break-before: always;
        break-before: page;
      "
    >
      <div style="width: 100%">
        <!-- 簡易ヘッダー -->
        <header
          style="
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 20px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 6px;
          "
        >
          <h1
            style="
              font-size: 14pt;
              font-weight: 700;
              color: #222;
              margin: 0;
              letter-spacing: 0.5px;
            "
          >
            {{ fullName }}
          </h1>
          <span style="font-size: 9.5pt; color: #888">Page 2</span>
        </header>

        <!-- EXPERIENCE 続き -->
        <section>
          <h2
            style="
              display: block;
              font-size: 20px;
              font-weight: 700;
              letter-spacing: 1.5px;
              margin: 0 0 12px;
              text-transform: uppercase;
              text-align: left;
              color: #222;
              border-bottom: 2px solid #222;
              padding-bottom: 3px;
            "
          >
            EXPERIENCE (continued)
          </h2>
          <div
            :data-highlight="highlightMessage"
            @click="goCardTo('job-history')"
            :class="highLightClass('job-history')"
          >
            <template v-for="job in jobsPage2">
              <div
                v-for="(project, pIndex) in job.projects && job.projects.length
                  ? job.projects
                  : [null]"
                :key="job.uuid + '-p2-' + pIndex"
                style="margin-bottom: 10px"
              >
                <h3
                  v-if="project && project.projectTitle"
                  style="
                    display: block;
                    font-size: 11pt;
                    font-weight: 700;
                    color: #222;
                    text-align: left;
                    margin: 0;
                  "
                >
                  {{ project.projectTitle }}
                </h3>
                <h3
                  v-else-if="pIndex === 0 && job.companyName"
                  style="
                    display: block;
                    font-size: 11pt;
                    font-weight: 700;
                    color: #222;
                    text-align: left;
                    margin: 0;
                  "
                >
                  {{ job.companyName }}
                </h3>
                <p style="margin: 0; font-size: 9.5pt; color: #555">
                  {{ formatExperiencePeriod(job, project) }}
                </p>
                <p
                  v-if="job.companyName"
                  style="margin: 0 0 2px; font-style: italic"
                >
                  {{ job.companyName }}
                </p>
                <pre
                  v-if="project && project.contentsOfProject"
                  style="
                    font-family: inherit;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    margin: 0;
                    font-size: 10pt;
                    line-height: 1.5;
                  "
                  >{{ project.contentsOfProject }}</pre>
                <pre
                  v-else-if="!project && job.businessArea"
                  style="
                    font-family: inherit;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    margin: 0;
                    font-size: 10pt;
                    line-height: 1.5;
                  "
                  >{{ job.businessArea }}</pre>
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewMixin from '@/mixins/preview-mixin'

const MONTH_NAMES_SHORT = [
  '',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
]

// 1ページ目に乗せる職歴件数。
// prMessage 350文字制限を前提に、件数固定3件まで収まる。
const JOBS_PER_PAGE = 3

export default {
  name: 'EnglishResumePreview',
  mixins: [PreviewMixin],
  computed: {
    isTwoPage: function () {
      return (
        this.formatData &&
        this.formatData.jobHistories &&
        this.formatData.jobHistories.length > JOBS_PER_PAGE
      )
    },
    jobsPage1: function () {
      const jobs = (this.formatData && this.formatData.jobHistories) || []
      if (!this.isTwoPage) return jobs
      return jobs.slice(0, JOBS_PER_PAGE)
    },
    jobsPage2: function () {
      const jobs = (this.formatData && this.formatData.jobHistories) || []
      if (!this.isTwoPage) return []
      return jobs.slice(JOBS_PER_PAGE)
    },
    fullName: function () {
      const first = this.basicData.firstName || ''
      const last = this.basicData.lastName || ''
      return `${first} ${last}`.trim()
    },
    fullAddress: function () {
      return this.formatData && this.formatData.address
        ? this.formatData.address
        : ''
    },
    fullPhone: function () {
      const t1 = this.basicData.tel1 || ''
      const t2 = this.basicData.tel2 || ''
      const t3 = this.basicData.tel3 || ''
      if (!t1 && !t2 && !t3) return ''
      return [t1, t2, t3].filter(Boolean).join('-')
    },
    formatedCreateDate: function () {
      if (!this.formatData || !this.formatData.createDate) {
        return ''
      }
      return this.$formLib.dateFormat(this.formatData.createDate, 'm/yyyy')
    }
  },
  methods: {
    formatMonthYear: function (month, year) {
      if (!year && !month) return ''
      const mm = month
        ? MONTH_NAMES_SHORT[Number(month)] || String(month).padStart(2, '0')
        : ''
      if (mm && year) return `${mm}/${year}`
      if (year) return `${year}`
      if (mm) return mm
      return ''
    },
    formatExperiencePeriod: function (job, project) {
      if (project) {
        const start = this.formatMonthYear(
          project.startMonth,
          project.startYear
        )
        if (project.endYear || project.endMonth) {
          const end = this.formatMonthYear(project.endMonth, project.endYear)
          return start && end ? `${start} - ${end}` : start || end
        } else if (
          job.isContinuing ||
          (!project.endYear &&
            !project.endMonth &&
            !project.startYear &&
            !project.startMonth)
        ) {
          return start ? `${start} - Present` : ''
        }
        return start
      } else {
        const start = this.formatMonthYear(job.startMonth, job.startYear)
        if (job.isContinuing) {
          return start ? `${start} - Present` : 'Present'
        }
        const end = this.formatMonthYear(job.endMonth, job.endYear)
        return start && end ? `${start} - ${end}` : start || end
      }
    }
  }
}
</script>
